import { FC } from "react";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Container from "react-bootstrap/Container";
import Table from "react-bootstrap/Table";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FaEdit, FaTrash } from "react-icons/fa";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import {
    deleteTestTypePrerequisiteRoute,
    editTestTypePrerequisiteRoute,
    testTypePrerequisiteRoute,
} from "app/route/Routes";
import { useRouteParams } from "app/route/route";
import { useTestTypePrerequisiteQuery } from "app/api/graph/types";
import { testTypePrerequisiteGraphId } from "app/api/graph/helpers";
import { LoadingScreen } from "app/component/screen/LoadingScreen";
import { ErrorScreen } from "app/component/screen/ErrorScreen";
import { ButtonLink } from "app/component/button/ButtonLink";
import { useGeneralPermissions } from "app/api/graph/hook/use-general-permissions";
import { testTypeLabel } from "app/api/graph/strings";

export const TestTypePrerequisiteScreen: FC = () => {
    const { testTypePrerequisiteId } = useRouteParams(testTypePrerequisiteRoute);
    const { data, loading, error } = useTestTypePrerequisiteQuery({
        variables: { testTypePrerequisiteId: testTypePrerequisiteGraphId(testTypePrerequisiteId) },
    });
    const testTypePrerequisite = data?.testTypePrerequisite;
    const permissions = useGeneralPermissions(testTypePrerequisite?.permissions);

    if (loading) {
        return <LoadingScreen />;
    }
    if (error) {
        return <ErrorScreen title="Error" message={error.message} />;
    }
    if (!testTypePrerequisite) {
        return <ErrorScreen title="Error" message="Not found." />;
    }

    return (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={testTypePrerequisiteRoute} />
                <Row>
                    <Col xs="auto" className="ms-auto">
                        <ButtonGroup>
                            {permissions.canUpdate ? (
                                <ButtonLink
                                    to={editTestTypePrerequisiteRoute.build({
                                        testTypePrerequisiteId,
                                    })}
                                    variant="warning"
                                >
                                    <FaEdit /> Edit
                                </ButtonLink>
                            ) : null}
                            {permissions.canDelete ? (
                                <ButtonLink
                                    to={deleteTestTypePrerequisiteRoute.build({
                                        testTypePrerequisiteId,
                                    })}
                                    variant="danger"
                                >
                                    <FaTrash /> Delete
                                </ButtonLink>
                            ) : null}
                        </ButtonGroup>
                    </Col>
                </Row>
                <h1>Test type prerequisite</h1>
                <Table responsive="sm">
                    <tbody>
                        <tr>
                            <th>Test type</th>
                            <td>{testTypeLabel(testTypePrerequisite.testType)}</td>
                        </tr>
                        <tr>
                            <th>Description</th>
                            <td>{testTypePrerequisite.description}</td>
                        </tr>
                    </tbody>
                </Table>
            </Container>
        </NavigationScreen>
    );
};
